import get from 'lodash/get';
import PerformanceEntries from '@Services/PerformanceEntries';
import AccountData from '@Services/AccountData';

class Usabilla {
  static SCRIPT1 = '/e0fb27bc6223.js';

  static SCRIPT2 = '/baaad4811ce0.js';

  static USABILLA_LIVE_FN_NAME = 'usabilla_live';

  isInitialized = false;

  init(disableTracking) {
    if (this.isInitialized) {
      return;
    }

    const usabillaURL = window.BUILD.getUsabillaURL();
    const usabillaInit = get(window, 'lightningjs.require', () => {});

    if (!usabillaURL) {
      // if false, it's default, otherwise overriden
      // Don't know what are these scripts, if it works - so be it ¯\_(ツ)_/¯
      // Only found reference to the original implementation - RXFE-2660
      if (!navigator.userAgent.match(/Android|BlackBerry|BB10|iPhone|iPad|iPod|Opera Mini|IEMobile/i)) {
        window[this.constructor.USABILLA_LIVE_FN_NAME] = usabillaInit(
          this.constructor.USABILLA_LIVE_FN_NAME,
          window.BUILD.getUsabillaURL(this.constructor.SCRIPT1)
        );
      } else {
        window[this.constructor.USABILLA_LIVE_FN_NAME] = usabillaInit(
          this.constructor.USABILLA_LIVE_FN_NAME,
          window.BUILD.getUsabillaURL(this.constructor.SCRIPT2)
        );
      }
      this.isInitialized = true;
    } else if (!disableTracking) {
      window[this.constructor.USABILLA_LIVE_FN_NAME] = usabillaInit(this.constructor.USABILLA_LIVE_FN_NAME, usabillaURL);
      this.isInitialized = true;
    }
  }

  sendToUsabilla() {
    const chunks = PerformanceEntries.getStatisticChunksForUsabilla();
    const visitorData = AccountData.getVisitorData();

    if (window[this.constructor.USABILLA_LIVE_FN_NAME]) {
      window[this.constructor.USABILLA_LIVE_FN_NAME]('data', {
        custom: {
          loadtimes: chunks,
          userId: visitorData.userId,
          accountId: visitorData.accountId,
          accountName: visitorData.accountName,
          departmentId: visitorData.departmentId,
          license: visitorData.usabillaLicense,
        },
      });
      window[this.constructor.USABILLA_LIVE_FN_NAME]('click');
    }
  }
}

export default new Usabilla();
